import type { ElementType } from 'react'
import { useTypography } from './useTypography'
import type { TypographyProps } from './Typography.types'

export function Typography({
  as,
  variant = 'body',
  color = 'primary',
  className,
  children,
  ...props
}: TypographyProps) {
  const { classes, defaultTag } = useTypography(variant, color, className)
  const Tag = (as ?? defaultTag) as ElementType

  return (
    <Tag className={classes} {...props}>
      {children}
    </Tag>
  )
}
